"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCycle = exports.getGenericCycle = void 0;
const utils_1 = require("../../utils");
const analytics_1 = require("../analytics");
const getGenericCycle = ({ state, businessUnit }) => __awaiter(void 0, void 0, void 0, function* () {
    return utils_1.apiClient
        .get('/cycle/generic', {
        params: { state },
        headers: {
            'x-business-unit': businessUnit,
        },
    })
        .then((res) => res.data)
        .catch((error) => {
        if (error.response) {
            analytics_1.GoogleAnalyticsService.event({
                event: 'ga-event',
                'event-category': 'erro-na-aplicacao',
                'event-action': 'display',
                'event-label': `cycle-error-${error.response.status}`,
            });
        }
        throw error;
    });
});
exports.getGenericCycle = getGenericCycle;
/**
 * @deprecated use getGenericCycle instead
 * @see {@link getGenericCycle}
 */
exports.getCycle = exports.getGenericCycle;
